/** Header that names the browser tab's edit session on every write the authenticated clients make (shared/api/session.ts), so a page
 * write joins (or takes) the person's lease: an HTML page's editing session, a native chart's lease. */
export const EDIT_SESSION_HEADER = 'X-Unity-Edit-Session';
const STORAGE_KEY = 'unity-html-edit-session';
let fallback: string | undefined;

/** This tab's edit session: one per tab, kept across reloads, never shared between tabs. */
export function editSessionId(): string {
  try {
    let id = window.sessionStorage.getItem(STORAGE_KEY);
    if (!id) { id = crypto.randomUUID(); window.sessionStorage.setItem(STORAGE_KEY, id); }
    return id;
  } catch {
    // Storage can be unavailable (private modes); the session then lasts as long as the page.
    fallback ??= crypto.randomUUID();
    return fallback;
  }
}

/** The signed-in account's id (the display copy the session keeps), or null. */
export function signedInUserId(): string | null {
  try {
    const stored = window.localStorage.getItem('user');
    return stored ? JSON.parse(stored)?.userId ?? null : null;
  } catch { return null; }
}
